import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../API/EndPoints";
import AxiosInstance from "../API/AxiosInstance";

export const getSpecialPackages = createAsyncThunk(
  "specialPackages/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        API_ENDPOINTS.GET_SPECIAL_PACKAGES
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const createBookingPackage = createAsyncThunk(
  "specialPackages/createBookingPackage",
  async (payload, { rejectWithValue }) => {
    try {
      // const response = await AxiosInstance.post(
      //   API_ENDPOINTS.CREATE_BOOK_PACKAGE,
      //   payload
      // );
      const token = localStorage.getItem("token");
      const endpoint = token
        ? API_ENDPOINTS.CREATE_BOOK_PACKAGE
        : API_ENDPOINTS.CREATE_BOOK_PACKAGE_GUEST;
      const response = await AxiosInstance.post(endpoint, payload);

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const specialPackagesSlice = createSlice({
  name: "specialPackages",
  initialState: {
    items: [],
    loading: false,
    error: null,
    booking: {
      items: [],
      loading: false,
      error: null,
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 🔹 Get All
      .addCase(getSpecialPackages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSpecialPackages.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getSpecialPackages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createBookingPackage.pending, (state) => {
        state.booking.loading = true;
        state.booking.error = null;
      })
      .addCase(createBookingPackage.fulfilled, (state, action) => {
        state.booking.loading = false;
        state.booking.items = action.payload;
      })
      .addCase(createBookingPackage.rejected, (state, action) => {
        state.booking.loading = false;
        state.booking.error = action.payload;
      });
  },
});

export default specialPackagesSlice.reducer;
